import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-card border border-border rounded-lg p-3 shadow-elevation-2">
        <p className="text-sm font-medium text-foreground mb-2">{label}</p>
        {payload.map((entry, index) => (
          <p key={index} className="text-sm" style={{ color: entry.color }}>
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

const SurveyTrendsChart = ({ data = [], completionRate = 0 }) => {
  const current = data[data.length - 1] || {};
  const prev = data[data.length - 2] || {};
  const growth = prev.surveys > 0
    ? (((current.surveys - prev.surveys) / prev.surveys) * 100).toFixed(1)
    : 0;

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-foreground">Survey Trends</h3>
        </div>
        <div className="flex items-center space-x-4 text-sm">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 rounded-full bg-primary" />
            <span className="text-muted-foreground">Surveys</span>
          </div>
        </div>
      </div>

      <div className="w-full h-64" aria-label="Survey Trends Line Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis dataKey="month" stroke="var(--color-muted-foreground)" fontSize={12} />
            <YAxis stroke="var(--color-muted-foreground)" fontSize={12} />
            <Tooltip content={<CustomTooltip />} />
            <Line type="monotone" dataKey="surveys" stroke="var(--color-primary)" strokeWidth={3} dot={{ fill: 'var(--color-primary)', strokeWidth: 2, r: 4 }} name="Surveys" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-6 pt-4 border-t border-border">
        <div className="text-center">
          <p className="text-2xl font-bold text-foreground">{current.surveys ?? 0}</p>
          <p className="text-sm text-muted-foreground">This Month</p>
        </div>
        <div className="text-center">
          <p className={`text-2xl font-bold ${growth >= 0 ? 'text-success' : 'text-error'}`}>
            {growth >= 0 ? '+' : ''}{growth}%
          </p>
          <p className="text-sm text-muted-foreground">Growth Rate</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-accent">{completionRate}%</p>
          <p className="text-sm text-muted-foreground">Completion Rate</p>
        </div>
      </div>
    </div>
  );
};

export default SurveyTrendsChart;
